module.exports = __webpack_public_path__ + "img/symbol_2.a921ab67.png";